<template>
  <div class="intake-object">
    <div class="intake-object__item">
      <div class="intake-object__title flex-grow-1">
        <input
          class="form-control"
          type="text"
          :id="`title-${index}`"
          :value="object.title"
          @input="(e) => updateObjectField([object, 'title', e.target.value])"
          placeholder="Object naam"
        >
      </div>

      <div class="intake-object__quantity flex-grow-0">
        <button
          class="btn btn--secondary btn--sm btn--icon-only flex-shrink-0"
          type="button"
          :disabled="object.count <= 0"
          @click="() => updateObjectCountField([object, 'decrement'])"
        >
          -
        </button>

        <input
          class="form-control flex-grow-1"
          type="number"
          :id="`amount-${index}`"
          min="0"
          max="9999"
          :value="object.count"
          @input="(e) => updateObjectCountField([object, parseInt(e.target.value, 10)])"
        >

        <button
          class="btn btn--secondary btn--sm btn--icon-only flex-shrink-0"
          type="button"
          :disabled="object.count >= 9999"
          @click="() => updateObjectCountField([object, 'increment'])"
        >
          +
        </button>
      </div>

      <button
        v-if="currentSite !== 'inboedelopslag'"
        class="btn btn--sm btn--icon-only flex-shrink-0 ml-2"
        :class="{ 'btn--primary': object.properties['demontage'] }"
        type="button"
        title="De- & montage van dit meubelstuk door Van Beek?"
        @click="() => updateObjectField([
          object.properties,
          'demontage',
          !object.properties['demontage']
        ])"
      >
        <Icon name="wrench" />
      </button>

      <button
        class="btn btn--sm btn--icon-only flex-shrink-0 ml-2"
        type="button"
        title="Verwijder object"
        @click="() => removeObjectFromRoom([selectedRoom, index])"
      >
        <Icon name="trash" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Icon from '@/intake/components/Icon.vue';

export default {
  props: {
    index: {
      type: Number,
      required: true,
      default: 0,
    },

    object: {
      type: Object,
      required: true,
      default: () => {},
    },
  },

  components: {
    Icon,
  },

  computed: {
    ...mapGetters({
      currentSite: 'currentSite',
      selectedRoom: 'room/selectedRoom',
      selectedRoomIndex: 'room/selectedRoomIndex',
    }),
  },

  methods: {
    ...mapMutations({
      updateObjectField: 'room/updateObjectField',
      updateObjectCountField: 'room/updateObjectCountField',
      updateObjectPropertiesField: 'room/updateObjectPropertiesField',
      removeObjectFromRoom: 'room/removeObjectFromRoom',
    }),
  }
};
</script>
